import React from 'react'

import { feedbotToast } from '../../../../../../lib/feedbotToast'

export const toastNotifyDownloadNlpLogsSuccess = (logCount: number) => {
  const id = 'downloadNlpLogsSuccess'
  const title = 'Download NLP logs'

  const content = (
    <>Nlp logs were successfully downloaded. Number of downloaded logs is {logCount}.</>
  )

  feedbotToast.success({ title, content, id })
}

export const toastNotifyDownloadNlpLogsInfo = () => {
  const id = 'downloadNlpLogsInfo'
  const title = 'Download NLP logs'

  const content = <>There were not found any NLP logs for download with given date range.</>

  feedbotToast.info({ title, content, id })
}

export const toastNotifyDownloadNlpLogsError = () => {
  const id = 'downloadNlpLogsError'
  const title = 'Download NLP logs'

  const content = <>Download NLP logs has failed.</>

  feedbotToast.error({ title, content, id })
}
